import { Button } from '../button'

interface SyncInsuranceDataButtonProps {
  lastSyncedAt: string | null
  onSync: () => void
  disabled?: boolean
}

export function SyncInsuranceDataButton({
  lastSyncedAt,
  onSync,
  disabled,
}: SyncInsuranceDataButtonProps) {
  return (
    <div className="flex flex-col items-end gap-2">
      <Button
        type="button"
        variant="tertiary"
        onClick={onSync}
        disabled={disabled}
        className="gap-2 px-4 py-2"
      >
        <i className="fa-solid fa-rotate" aria-hidden />
        <span>Sync insurance data</span>
      </Button>

      {lastSyncedAt && (
        <span className="text-sm text-charcoal-25">last synced {formatSyncTime(lastSyncedAt)}</span>
      )}
    </div>
  )
}

function formatSyncTime(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  const dateStr = date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    timeZone: 'America/New_York',
  })
  const timeStr = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'America/New_York',
    timeZoneName: 'short',
  })
  return `${dateStr} at ${timeStr}`
}
